module.exports = __webpack_public_path__ + "img/partner-list-4.452017dc.png";